export default __webpack_public_path__ + "1969cec3ce249ff95073443971f56c84.png";